import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const TDIRPlatform = () => {
  const features = [
    "Transition to a cloud-native SIEM",
    "Replace an on-premises SIEM",
    "Consolidate multiple SIEM tools",
    "Augment your SIEM with behavioral analytics",
    "Add AI and automation to an existing SIEM",
    "Integrate TDIR with a single UI",
    "Start an insider threat program"
  ];

  return (
    <section className="feature-section">
      <div className="container" style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
        gap: '48px', 
        alignItems: 'center'
      }}>
        <motion.div 
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 style={{ 
            fontSize: 'clamp(32px, 4vw, 48px)', 
            fontWeight: 'bold', 
            marginBottom: '1.5rem',
            letterSpacing: '-0.04em',
            color: 'var(--gh-text)'
          }}>
            The Leading Platform for TDIR
          </h2>
          
          <p style={{ 
            color: 'var(--gh-text-muted)', 
            fontSize: '1.1rem', 
            lineHeight: '1.6', 
            marginBottom: '2rem' 
          }}>
            Realize the full potential of your security operations with the cloud-native PassiveGuard Security Operations Platform, or the self-hosted PassiveGuard SIEM Platform.
          </p>

          <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 2.5rem 0' }}>
            {features.map((item, index) => (
              <motion.li 
                key={index}
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  marginBottom: '0.9rem',
                  fontSize: '1.1rem',
                  color: 'var(--gh-text)'
                }}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1, duration: 0.3 }}
                viewport={{ once: true }}
              >
                <div style={{ 
                  width: '24px', 
                  height: '24px', 
                  border: '1px solid rgba(63, 185, 80, 0.45)', 
                  borderRadius: '50%',
                  background: 'rgba(63, 185, 80, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '1rem',
                  flexShrink: 0
                }}>
                  <svg viewBox="0 0 24 24" width="14" height="14" stroke="var(--gh-success)" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                {item}
              </motion.li>
            ))}
          </ul>

          <Link to="/platform" className="gh-btn gh-btn-primary">
            Understand the Platform
          </Link>
        </motion.div>

        <motion.div 
          style={{ display: 'flex', justifyContent: 'center' }}
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <div style={{
            position: 'relative',
            width: '100%',
            maxWidth: '600px',
            aspectRatio: '16/10',
            background: 'var(--gh-bg-secondary)',
            border: '1px solid var(--gh-border)',
            boxShadow: '0 24px 60px rgba(1, 4, 9, 0.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden'
          }}>
            <div style={{ position: 'absolute', top: '10%', left: '10%', right: '10%', bottom: '10%', background: 'var(--gh-bg)', border: '1px solid var(--gh-border)', overflow: 'hidden' }}>
                <div style={{ height: '28px', background: 'var(--gh-bg-secondary)', borderBottom: '1px solid var(--gh-border)', display: 'flex', alignItems: 'center', padding: '0 10px' }}>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--gh-danger)', marginRight: '6px' }}></div>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--gh-warning)', marginRight: '6px' }}></div>
                    <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: 'var(--gh-success)' }}></div>
                    <div style={{ marginLeft: '10px', height: '14px', background: 'var(--gh-bg)', flex: 1, border: '1px solid var(--gh-border)' }}></div>
                </div>

                <div style={{ display: 'flex', height: 'calc(100% - 28px)' }}>
                   <div style={{ width: '44px', background: 'var(--gh-bg-secondary)', borderRight: '1px solid var(--gh-border)', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '12px', gap: '10px' }}>
                      <div style={{ width: '20px', height: '20px', background: 'rgba(88, 166, 255, 0.16)', border: '1px solid rgba(88, 166, 255, 0.4)' }}></div>
                      <div style={{ width: '20px', height: '2px', background: 'var(--gh-border)' }}></div>
                      <div style={{ width: '16px', height: '16px', background: 'var(--gh-border)' }}></div>
                      <div style={{ width: '16px', height: '16px', background: 'var(--gh-border)' }}></div>
                      <div style={{ width: '16px', height: '16px', background: 'var(--gh-border)' }}></div>
                   </div>

                   <div style={{ flex: 1, padding: '15px' }}>
                      <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                          <div style={{ flex: 1, background: 'rgba(248, 81, 73, 0.1)', border: '1px solid rgba(248, 81, 73, 0.4)', padding: '8px' }}>
                             <div style={{ color: 'var(--gh-danger)', fontSize: '10px', fontWeight: 'bold' }}>HIGH RISK</div>
                             <div style={{ color: 'var(--gh-text)', fontSize: '18px', fontWeight: 'bold' }}>12</div>
                          </div>
                          <div style={{ flex: 1, background: 'rgba(210, 153, 34, 0.1)', border: '1px solid rgba(210, 153, 34, 0.4)', padding: '8px' }}>
                             <div style={{ color: 'var(--gh-warning)', fontSize: '10px', fontWeight: 'bold' }}>MEDIUM</div>
                             <div style={{ color: 'var(--gh-text)', fontSize: '18px', fontWeight: 'bold' }}>45</div>
                          </div>
                           <div style={{ flex: 1, background: 'rgba(88, 166, 255, 0.1)', border: '1px solid rgba(88, 166, 255, 0.4)', padding: '8px' }}>
                             <div style={{ color: 'var(--gh-link)', fontSize: '10px', fontWeight: 'bold' }}>LOW</div>
                             <div style={{ color: 'var(--gh-text)', fontSize: '18px', fontWeight: 'bold' }}>128</div>
                          </div>
                      </div>

                      <div style={{ height: '80px', display: 'flex', alignItems: 'flex-end', gap: '8px', paddingBottom: '10px', borderBottom: '1px solid var(--gh-border)', marginBottom: '10px' }}>
                         {[40, 60, 30, 80, 50, 90, 45, 70, 35, 60, 85, 55].map((h, i) => (
                            <div key={i} style={{ 
                               flex: 1, 
                               height: `${h}%`, 
                               background: h > 70 ? 'var(--gh-danger)' : h > 40 ? 'var(--gh-warning)' : 'var(--gh-link)',
                               opacity: 0.8
                            }}></div>
                         ))}
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                         <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '9px', color: 'var(--gh-text-muted)' }}>
                            <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: 'var(--gh-danger)' }}></div>
                            <div style={{ color: 'var(--gh-text)' }}>SQL Injection Detected</div>
                            <div style={{ marginLeft: 'auto' }}>10m ago</div>
                         </div>
                         <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '9px', color: 'var(--gh-text-muted)' }}>
                            <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: 'var(--gh-warning)' }}></div>
                            <div style={{ color: 'var(--gh-text)' }}>Privileged Container</div>
                            <div style={{ marginLeft: 'auto' }}>2h ago</div>
                         </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '9px', color: 'var(--gh-text-muted)' }}>
                            <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: 'var(--gh-link)' }}></div>
                            <div style={{ color: 'var(--gh-text)' }}>Outdated Dependency</div>
                            <div style={{ marginLeft: 'auto' }}>5h ago</div>
                         </div>
                      </div>

                   </div>
                </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TDIRPlatform;
